export default __webpack_public_path__ + "113dae2fff4fd8aa92336ed146de2dbb.svg";